import React, { useEffect } from 'react'
import { Typography, Button } from '@material-ui/core'
import { MAP_ID } from '../../../utils/apiHelper'
import {
  useGlobalContext,
  layerAdded,
  layerVisibilityChanged,
  externalTabChange
} from '../../../state'
import { useMapEngine } from '../../shared'
import { LAYER_KIND } from '../../../utils/configQueries'

import { useLayer } from '@facility-latam/geoportal-components'

import { useStyles } from '../styles'

export const ExternalLayer = ({ data, idLayer, name }) => {
  const { state, dispatch } = useGlobalContext()
  const [engine] = useMapEngine(MAP_ID)
  const classes = useStyles()

  const isVisible =
    state.layers.find(({ id }) => `external_${idLayer}` === id)?.isVisible ??
    false
  const id = `external_${idLayer}`

  useLayer({
    engine,
    source: {
      id,
      type: 'raster',
      tiles: [
        // eslint-disable-next-line max-len
        `https://geoportal.cepal.org/geoserver/ows?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=${data}`
      ],
      tileSize: 256
    },
    layer: {
      id,
      type: 'raster',
      source: id,
      layout: {
        visibility: 'none'
      },
      paint: {}
    }
  })

  useEffect(() => {
    if (engine) {
      engine.setLayoutProperty(id, 'visibility', isVisible ? 'visible' : 'none')
    }
  }, [id, isVisible, engine])

  const onExternalLayer = () => {
    dispatch(
      layerAdded({
        id,
        isVisible: true,
        metadata: { indicator_name: name, layer: data },
        membersValues: {},
        steps: [],
        dimensions: [],
        opacity: 100,
        includeValue: true,
        kind: LAYER_KIND.EXTERNAL
      })
    )
    dispatch(externalTabChange(true))
    dispatch(layerVisibilityChanged({ id, isVisible: !isVisible }))
  }

  return (
    <Button className={classes.externalLayer} onClick={onExternalLayer}>
      <Typography variant="h6">{name}</Typography>
    </Button>
  )
}
